import { FamilyMember } from 'src/non-financial-data/v2/family/useFamilyMembers';
import { GroupMember } from '../grouping';

export function toGroupMembers(members: FamilyMember[]): GroupMember[] {
  return members.map(member => ({
    clientId: member.clientId,
    firstName: member.client.firstName,
    lastName: member.client.lastName,
  }));
}

export function memberIndex(members: GroupMember[]): Map<string, GroupMember> {
  return new Map(members.map(member => [member.clientId, member]));
}
